import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LegalPageContainer,
  BackButton,
  LegalHighlightBox,
  LegalSection,
  ContactBox
} from '../../styles/legal/LegalShared.styles';
import { useSEO } from '../../hooks';

export const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  useSEO({
    title: 'Terms of Service | Plenty of Hearts',
    description: 'The terms and conditions for using Plenty of Hearts.',
    canonical: '/terms-of-service',
  });

  return (
    <LegalPageContainer>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <BackButton onClick={() => navigate('/')}>
          ← Back to App
        </BackButton>

        <h1>Terms of Service</h1>

        <LegalHighlightBox>
          <p>Effective Date: September 23, 2025</p>
          <p>Last Updated: January 19, 2026</p>
        </LegalHighlightBox>

        <p>Welcome to Plenty of Hearts! These Terms of Service govern your use of our personality-first dating app. By using our services, you agree to be bound by these terms.</p>

        <LegalSection>
          <h2>1. Eligibility</h2>
          <p>To use Plenty of Hearts, you must:</p>
          <ul>
            <li>Be at least 18 years of age</li>
            <li>Be legally able to enter into a binding contract</li>
            <li>Provide accurate and truthful information during registration</li>
          </ul>
        </LegalSection>

        <LegalSection>
          <h2>2. User Conduct</h2>
          <p>We pride ourselves on being a respectful community. You agree not to:</p>
          <ul>
            <li>Harass, bully, or intimidate other users</li>
            <li>Create fake profiles or impersonate others</li>
            <li>Post any content that is offensive, illegal, or violates our guidelines</li>
            <li>Use the platform for any commercial solicitation or spam</li>
          </ul>
        </LegalSection>

        <LegalSection>
          <h2>3. Safety and Security</h2>
          <p>While we provide AI-assisted safety features and moderation, you are responsible for your interactions. We strongly encourage you to:</p>
          <ul>
            <li>Establish trust before sharing personal contact information</li>
            <li>Meet in public places for initial dates</li>
            <li>Report any suspicious or harmful behavior immediately</li>
          </ul>
        </LegalSection>

        <LegalSection>
          <h2>4. Premium Services</h2>
          <p>We offer subscription services with additional features. All purchases are final and non-refundable unless required by law. You can manage and cancel your subscriptions through your account settings.</p>
        </LegalSection>

        <ContactBox>
          <h2>Need clarification?</h2>
          <p>If you have questions about these terms, our legal team is available to assist.</p>
          <div className="methods">
            <div className="method">
              <span>Legal Support</span>
              <a href="mailto:legal@plentyofhearts.com">legal@plentyofhearts.com</a>
            </div>
          </div>
        </ContactBox>

        <div style={{ textAlign: 'center', color: '#8e9aaf', fontSize: '0.9em', marginTop: '60px' }}>
          © 2026 Plenty of Hearts. Building connections built on respect.
        </div>
      </div>
    </LegalPageContainer>
  );
};
